import React, { FC, Fragment } from "react";
import { useFormikContext } from "formik";
import { IRenderCalculatorStep } from "./types";
import { CalculatorField, CalculatorValues } from "./types";

interface Props {
  steps: IRenderCalculatorStep[];
}

export const RenderSteps: FC<Props> = ({ steps }) => {
  const { values } = useFormikContext<CalculatorValues>();
  const hiredWorkers = values[CalculatorField.hiredWorkers];

  // Крок з workersCount в responsibleFields — рендерити тільки при явному "Так"
  const stepsToRender = steps.filter((step) => {
    if (step.responsibleFields.includes(CalculatorField.workersCount)) {
      return hiredWorkers === true;
    }
    return true;
  });

  return (
    <Fragment>
      {stepsToRender.map(({ step: Step, ...props }, i) => (
        <Step key={props.id} {...props} withAnimation={Boolean(i)} />
      ))}
    </Fragment>
  );
};
